import type { ExtensionParams, Parameters } from '@atlaskit/editor-common/extensions';

/**
 * Determines if the extension should be displayed as inline based on the extension parameters.
 *
 * @param extensionParams - The extension parameters.
 * @returns True if the extension should be displayed as inline, false otherwise.
 */
export function shouldDisplayExtensionAsInline<T extends Parameters = Parameters>(
	extensionParams?: ExtensionParams<T>,
): boolean {
	// Always display excerpt as block
	if (extensionParams?.extensionKey === 'excerpt') {
		return false;
	}

	return Boolean(
		extensionParams?.parameters?.macroParams?.['atlassian-macro-output-type']?.value === 'INLINE',
	);
}
